package at.apa.statistictracker.coroutines

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlin.time.Duration

/**
 * Starts a periodic task in the context of the receiver scope [this].
 * This periodic task runs infinitely long until the created job or the receiver scope [this] gets canceled.
 *
 * @param interval Duration until the passed [action] is executed the first time.
 * @param startDelay Duration of the wait time for the invocation of the passed [action] after the passed [action] has been executed.
 */
fun CoroutineScope.periodicTask(
    interval: Duration = Duration.ZERO,
    startDelay: Duration = interval,
    action: suspend () -> Unit
): Job = launch {
    delay(startDelay)
    do {
        action()
        delay(interval)
    } while (true)
}